<script>
export default {
    name: "PharmacyIssueReport",

    data() {

        return {
            filter: {
                from: this.$moment().format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                storeId: 0,
                itemId: 0,
                itemName: ``,
            },
            stores: [],
            outpatientsummary: [],
            itemIssueHistory: [],
            viewItemHistory: false,
            item: {},
            searchItem: false,
            items: [],
        };
    },

    mounted() {

        this.$root.loading = true;
        Promise.all([ this.fetchIssueReport() ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {
         
         

        fetchIssueReport() {
            let url = `Pharmacy/GetOutPatientPharmacySummary`;
                 url += `?Datefrom=${this.$route.query.Datefrom}&Dateto=${this.$route.query.Dateto}`;
                url += this.$route.query.itemId ? `&itemId=${this.$route.query.itemId}` : ``;
                 
            return this.$http.get(url).then(({ data }) => {
                this.outpatientsummary = data;
            }).catch(() => {});
        },

        fetchItemIssueHistory(item) {
            this.$root.loading = true;
            let url = `Pharmacy/GetPatientDrugIssueReport`;
                url += `?FromDate=${this.filter.from}`;
                url += `&ToDate=${this.filter.to}`;
                url += `&ItemId=${item.serviceId}`;

            return this.$http.get(url).then(({ data }) => {
                this.item = item;
                this.itemIssueHistory = data;
                this.$root.loading = false;
                this.viewItemHistory = true;
            }).catch(() => { this.$root.loading = false; });
        },
    },

    // components: {
    //     'item-issue-history': () => import('./modals/ItemIssueHistory.vue')
    // },
}
</script>
<template>
<div class="flex flex-wrap content-start">
    <div class="w-full my-2 p-1 text-center">
        <h5 class="font-bold text-base">Out Patient Pharmacy Summary</h5>
    </div>
    <!-- <div class="w-full p-tiny">
        <h5 class="font-semibold text-base">Payments Against Bills</h5>
    </div> -->
    <table class="table">
               <tr class="flex w-full" v-for="(patient, idx) in outpatientsummary.outPatientListPharmacy" :key="idx">
                  
            <table class="table">
            <thead class="bg-white-500 text-sm">
                <tr class="flex text-black w-full bg-blue-500">
                    <!-- <th class="p-tiny w-full"> {{ patient }}</th> -->
                    <th class="p-tiny  w-1/6">MRN:  {{ patient.patienT_ID }}</th>
                    <th class="p-tiny w-full"> NAME: {{ patient.names }}</th>
                    <th class="p-tiny  w-1/4"> DATE:  {{ patient.visitDate | dateFormat}}</th>
                    <th class="p-tiny  w-1/6"> AGE:  {{ patient.age }}</th>
                    <th class="p-tiny w-full"> DIAGNOSIS:  {{ patient.diagnosis }}</th>
                   
                    
                    
                </tr>
                <tr class="flex text-black w-full">
                    <th class="p-tiny w-1/6">Date</th>
                    <th class="p-tiny w-1/3">Item Name</th>
                    <th class="p-tiny w-1/6">Precription</th>
                    <th class="p-tiny w-1/6">Processed</th>
                    <th class="p-tiny w-1/6">Dosage Qty</th>
                    <th class="p-tiny w-1/6">Qty Issued</th>
                    <th class="p-tiny w-1/6">Qty Remaining</th>
                   <th class="p-tiny w-1/6">Requested By</th>
                    <th class="p-tiny w-1/6">Processed By</th>
                    <th class="p-tiny w-1/6">Payment</th>
                    <th class="p-tiny w-1/6">Payment Ref</th>
                   
                </tr>
            </thead>
           
            <tbody class="text-sm font-semibold bg-gray-100 flex flex-col items-center overflow-auto w-full" 
                >
                <tr class="flex w-full" v-for="(prescription, idx) in  outpatientsummary.outPatientPrescriptions.filter(g=>g.visitNo==patient.visitNo)" :key="idx">
                   
                    <td class="p-tiny w-1/6">{{ prescription.date | dateFormat }}</td>
                    <td class="p-tiny w-1/3">{{ prescription.service }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.prescription }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.isProcessed }}</td>
                   <td class="p-tiny w-1/6">{{ prescription.dosage }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.issuedQty }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.remainingDOsage }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.requestedBy }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.processedBy }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.payment }}</td>
                    <td class="p-tiny w-1/6">{{ prescription.paymentRefNo }}</td>
                    
                     
                </tr>
            </tbody>
        </table>
    </tr>
</table>
</div>
</template>